<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="home" @onSearch="onSearch" />
    <div class="banner-container">
      <el-carousel height="353px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="img img-cover" @click="bannerJump(item)">
            <img :src="item.Img" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="public-content gg-container">
      <div class="icon-item"><img src="../../assets/pc-images/gg-icon.png"></div>
      <div class="content">
        <el-carousel height="50px" direction="vertical" indicator-position="none" arrow="never">
          <el-carousel-item v-for="(item, index) in ggList" :key="index">
            <div class="word" @click="handleShowGg(item)">{{ item.Title }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="right-item"><img src="../../assets/pc-images/more-right-icon.png"></div>
    </div>
    <div class="ability-list-item public-content">
      <router-link class="ability-item" :to="{path: '/website'}">
        <img class="bg-icon" src="../../assets/pc-images/home-fzdj-icon.png" />
        <div class="content">
          <div class="title">分站搭建</div>
          <div class="subtitle">快速创建子站点平台</div>
          <div class="more img-cover"><img src="../../assets/pc-images/more-icon.png" /></div>
        </div>
      </router-link>
      <router-link class="ability-item" :to="{path: '/goodsIsBo'}">
        <img class="bg-icon" src="../../assets/pc-images/home-lllq-icon.png" />
        <div class="content">
          <div class="title">流量领取</div>
          <div class="subtitle">每日免费推广资源获取</div>
          <div class="more img-cover"><img src="../../assets/pc-images/more-icon.png" /></div>
        </div>
      </router-link>
      <div class="ability-item" @click="handleShowVip">
        <img class="bg-icon" src="../../assets/pc-images/home-sjhy-icon.png" />
        <div class="content">
          <div class="title">升级会员</div>
          <div class="subtitle">解锁专属特权与福利</div>
          <div class="more img-cover"><img src="../../assets/pc-images/more-icon.png" /></div>
        </div>
      </div>
      <router-link class="ability-item" :to="{path: '/contact'}">
        <img class="bg-icon" src="../../assets/pc-images/home-lxkf-icon.png" />
        <div class="content">
          <div class="title">联系客服</div>
          <div class="subtitle">7×24小时在线支持</div>
          <div class="more img-cover"><img src="../../assets/pc-images/more-icon.png" /></div>
        </div>
      </router-link>
    </div>
    <div class="class-list-item public-content">
      <div class="class-item">
        <van-tabs v-model="selectedClassId[0]" :ellipsis="false" :swipe-threshold="0" @change="handleSelectedClassChange">
          <van-tab :name="index" :title="item.Name" v-for="(item, index) in classList" :key="index" />
        </van-tabs>
      </div>
      <div v-if="selectedClassId[0] >= 0 && classList[selectedClassId[0]].Childern && classList[selectedClassId[0]].Childern.length > 0" class="class-child-item">
        <div class="class-name">{{ classList[selectedClassId[0]].Name }}</div>
        <van-tabs v-model="selectedClassId[1]" type="card" :ellipsis="false" :swipe-threshold="0" @change="handleSelectedClassChildChange">
          <van-tab :name="index" :title="item.Name" v-for="(item, index) in classList[selectedClassId[0]].Childern" :key="index" />
        </van-tabs>
        <div class="sort-list-item"  v-if="!(selectedClassId[1] >= 0 && classList[selectedClassId[0]].Childern && classList[selectedClassId[0]].Childern[selectedClassId[1]].Childern && classList[selectedClassId[0]].Childern[selectedClassId[1]].Childern.length > 0)">
          <div class="sort-item" @click="handleChangeSort('Wcsj')">
            <div class="name">完成时间</div>
            <div class="arrow">
              <div class="img img-cover">
                <img v-if="sort.Wcsj == 2" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
              <div class="img down img-cover">
                <img v-if="sort.Wcsj == 1" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
            </div>
          </div>
          <div class="sort-item" @click="handleChangeSort('Wcl')">
            <div class="name">完成率</div>
            <div class="arrow">
              <div class="img img-cover">
                <img v-if="sort.Wcl == 2" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
              <div class="img down img-cover">
                <img v-if="sort.Wcl == 1" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
            </div>
          </div>
          <div class="sort-item" @click="handleChangeSort('Jg')">
            <div class="name">订单价格</div>
            <div class="arrow">
              <div class="img img-cover">
                <img v-if="sort.Jg == 2" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
              <div class="img down img-cover">
                <img v-if="sort.Jg == 1" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedClassId[1] >= 0 && classList[selectedClassId[0]].Childern && classList[selectedClassId[0]].Childern[selectedClassId[1]].Childern && classList[selectedClassId[0]].Childern[selectedClassId[1]].Childern.length > 0" class="class-child-item">
        <div class="class-name">{{ classList[selectedClassId[0]].Childern[selectedClassId[1]].Name }}</div>
        <van-tabs v-model="selectedClassId[2]" type="card" :ellipsis="false" :swipe-threshold="0" @change="handleSelectedClassChildrenChange">
          <van-tab :name="index" :title="item.Name" v-for="(item, index) in classList[selectedClassId[0]].Childern[selectedClassId[1]].Childern" :key="index" />
        </van-tabs>
        <div class="sort-list-item">
          <div class="sort-item" @click="handleChangeSort('Wcsj')">
            <div class="name">完成时间</div>
            <div class="arrow">
              <div class="img img-cover">
                <img v-if="sort.Wcsj == 2" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
              <div class="img down img-cover">
                <img v-if="sort.Wcsj == 1" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
            </div>
          </div>
          <div class="sort-item" @click="handleChangeSort('Wcl')">
            <div class="name">完成率</div>
            <div class="arrow">
              <div class="img img-cover">
                <img v-if="sort.Wcl == 2" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
              <div class="img down img-cover">
                <img v-if="sort.Wcl == 1" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
            </div>
          </div>
          <div class="sort-item" @click="handleChangeSort('Jg')">
            <div class="name">订单价格</div>
            <div class="arrow">
              <div class="img img-cover">
                <img v-if="sort.Jg == 2" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
              <div class="img down img-cover">
                <img v-if="sort.Jg == 1" src="../../assets/images/arrow-icon-blue.png" />
                <img v-else src="../../assets/images/arrow-icon.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-goods-item public-content">
      <div v-if="finish && !loading && goodsList.length == 0" class="empty-item" style="padding-top: 50px">
        <div class="icon img-cover"><img src="../../assets/pc-images/empty-icon.png" /></div>
      </div>
      <div v-else class="goods-list-item">
        <div v-for="(item, index) in goodsList" :key="index" class="goods-item" @click="handleToGoodsDetail(item)">
          <div class="img img-cover">
            <img v-if="item.GoodsThumb" :src="item.GoodsThumb" />
            <img v-else src="../../assets/images/no-image-icon.png" />
          </div>
          <div class="name-item"><span v-if="item.Lable">{{ item.Lable }}</span> {{ item.GoodsName }}</div>
          <div class="footer-item">
            <div class="money">¥ <span>{{ item.GoodsPrice }}</span></div>
            <div class="btn" :class="item.IsClose == 1 ? 'not' : ''">{{ item.IsClose == 1 ? '暂停购买' : '立即购买' }} </div>
          </div>
        </div>
      </div>
      <div v-if="!finish && goodsList.length > 0" class="more-goods-btn" @click="getGoodsList">
        <van-loading v-if="loading" size="10" color="#5783fc" />
        <span v-else>查看更多</span>
      </div>
    </div>
    <template v-for="(item, index) in ggList">
      <van-dialog v-if="item.IsTan == 1" :key="index" :title="item.Title" v-model="item.show" :show-cancel-button="false" confirm-button-text="我知道了" type="danger" class-name="pc-dialog pc-gg-dialog">
        <div class="van-dialog__message">
          <div v-html="item.Content"></div>
        </div>
      </van-dialog>
    </template>
    <pcVipUpgradeComponent v-if="dialog.vip" ref="vipUpgradedDialog" @success="onSuccess" @close="dialog.vip = false" />
  </div>
</template>

<script>
import pcTabBarComponent from '../../components/pcTabBarComponent.vue'
import pcVipUpgradeComponent from '../../components/PcVipUpgradeComponent'
import { mapState,mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    pcTabBarComponent,
    pcVipUpgradeComponent
  },
  data() {
    return {
      bannerList: [],
      ggList: [],
      isBoGoodsId: 0,
      classList: [],
      selectedClassId: [],
      sort: {
        Wcsj: 0,
        Wcl: 0,
        Jg: 0
      },
      goodsList: [],
      pageCount: 18,
      page: 1,
      finish: false,
      loading: false,
      dialog: {
        vip: false
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  watch: {
  },
  mounted(){
    this.getBannerData()
    this.getGgList()
    this.handleGetSetting()
    this.getClassList()
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    onSuccess() {
      this.GetUserInfo()
    },
    handleShowVip() {
      this.dialog.vip = true
      this.$nextTick(() => {
        this.$refs.vipUpgradedDialog.open()
      })
    },
    async handleGetSetting() {
      var res = await this.$API.getSet.post({
        'Key': 'cz_show'
      })
      const { userInfo } = this
      if (userInfo && userInfo.Id) {
        if (userInfo.UserIsSs == 1 && parseFloat(userInfo.AllMoney) >= parseFloat(res.info)) {
          this.showSstz = true
        } else {
          this.showSstz = false
        }
      } else {
        if (res.info == -1) {
          this.showSstz = true
        } else {
          this.showSstz = false
        }
      }
    },
    async getBannerData() {
      const { websiteInfo } = this
      var res = await this.$API.bannerList.post({
        AdminId: websiteInfo.Id
      });
      let data = res.info || []
      this.bannerList = data.filter(item => item.Type > 10)
    },
    bannerJump(item) {
      if (item.ParentId && item.Type == 11) {
        this.$router.push({
          path: '/goodsDetail',
          query: {
            id: item.ParentId
          }
        })
      }
      if (item.ParentId && item.Type == 22) {
        window.location.href = item.ParentId
      }
    },
    async getGgList() {
      const { websiteInfo } = this
      var res = await this.$API.announcedList.post({
        AdminId: websiteInfo.Id
      });
      if (res && res.info && res.info.length > 0) {
        const data = []
        for (let index = 0; index < res.info.length; index++) {
          const item = res.info[index]
          data.push({
            ...item,
            show: true
          })
        }
        this.ggList = data
      }
    },
    handleShowGg(data) {
      this.$dialog.alert({
        type: 'danger',
        className: 'pc-dialog pc-gg-dialog',
        title: data.Title,
        message: data.Content,
        confirmButtonText: '我知道了',
      })
    },
    onSearch(val) {
      this.goodsName = val
      this.finish = false
      this.loading = false
      this.page = 1
      this.goodsList = []
      this.getGoodsList()
    },
    async getClassList() {
      var res = await this.$API.goodsCategoryList.post({
        IsAll: 1
      });
      this.classList = res.info || []
      this.handleSelectedClassChange(0)
      this.getGoodsList()
    },
    handleSelectedClassChange(value) {
      const { classList } = this
      const list = [value]
      if (classList[value] && classList[value].Childern && classList[value].Childern.length > 0) {
        list.push(0)
        if (classList[value].Childern[0].Childern && classList[value].Childern[0].Childern.length > 0) {
          list.push(0)
        }
      }
      this.selectedClassId = list
      this.finish = false
      this.loading = false
      this.page = 1
      this.goodsList = []
      this.getGoodsList()
    },
    handleSelectedClassChildChange(value) {
      const { classList, selectedClassId } = this
      const list = [selectedClassId[0], value]
      if (classList[selectedClassId[0]].Childern[value].Childern && classList[selectedClassId[0]].Childern[value].Childern.length > 0) {
        list.push(0)
      }
      this.selectedClassId = list
      this.finish = false
      this.loading = false
      this.page = 1
      this.goodsList = []
      this.getGoodsList()
    },
    handleSelectedClassChildrenChange(value) {
      const { selectedClassId } = this
      const list = [selectedClassId[0], selectedClassId[1], value]
      this.selectedClassId = list
      this.finish = false
      this.loading = false
      this.page = 1
      this.goodsList = []
      this.getGoodsList()
    },
    handleChangeSort(key) {
      const { sort } = this
      this.sort[key] = sort[key] == 1 ? 2 : 1
      this.finish = false
      this.loading = false
      this.page = 1
      this.goodsList = []
      this.getGoodsList()
    },
    async getGoodsList() {
      const { userInfo } = this
      if (userInfo && userInfo.Id && userInfo.UserIsGoods != 1) {
        this.finish = true
        this.loading = false
        return
      }
      const { pageCount, page, goodsList, goodsName, websiteInfo, classList, selectedClassId, sort, finish, loading } = this
      if (finish || loading) {
        return
      }
      const params = {
        PageCount: pageCount, 
        Page: page,
        AdminId: websiteInfo.Id,
        Wcsj: sort.Wcsj,
        Wcl: sort.Wcl,
        Jg: sort.Jg
      }
      if (goodsName) {
        params.GoodsName = goodsName
      } else {
        params.IsIndex = 1
      }
      if (selectedClassId[0] >= 0) {
        params.CategoryId = classList[selectedClassId[0]].Id
      }
      if (selectedClassId[1] >= 0) {
        params.CategoryId2 = classList[selectedClassId[0]].Childern[selectedClassId[1]].Id
      }
      if (selectedClassId[2] >= 0) {
        params.CategoryId3 = classList[selectedClassId[0]].Childern[selectedClassId[1]].Childern[selectedClassId[2]].Id
      }
      this.loading = true
      var res = await this.$API.goodsList.post(params)
      if (page == 1) {
        this.goodsList = [
          ...res.info
        ]
      } else {
        this.goodsList = [
          ...goodsList,
          ...res.info
        ]
      }
      
      this.page = page + 1
      this.finish = res.info.length < pageCount
      this.loading = false
    },

    handleToGoodsDetail(item) {
      if (item.IsClose == 1) {
        return
      }
      this.$router.push({
        path: '/goodsDetail',
        query: {
          id: item.Id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.banner-container {
  min-width: 1200px;
  .img {
    width: 100%;
    height: 353px;
  }
}
.gg-container {
  position: relative;
  z-index: 2;
  height: 50px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 25px;
  margin-top: -25px;
  box-shadow: -4px 0px 10px  #5783fc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    border-color: #5783fc;
  }
  .icon-item {
    width: 30px;
    height: 30px;
    margin-left: 30px;
  }
  .content {
    flex: 1;
    padding: 0 35px;
    .word {
      font-size: 16px;
      color: #64748b;
      line-height: 50px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;
    }
  }
  .right-item {
    width: 16px;
    height: 16px;
    margin-right: 30px;
  }
}
.ability-list-item {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ability-item {
    cursor: pointer;
    width: 280px;
    height: 75px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    &:nth-child(2n-1) {
      background-color: #e3f4ff;
    }
    &:nth-child(2n) {
      background-color: #eaeeff;
    }
  }
  .bg-icon {
    width: 65px;
    height: 65px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .content {
    position: relative;
    padding: 18px 0 0 23px;
    z-index: 1;
    .title {
      line-height: 24px;
      font-size: 16px;
      font-weight: 500;
      color: #383838;
    }
    .subtitle {
      font-size: 10px;
      line-height: 15px;
      color: #64748b;
    }
    .more {
      position: absolute;
      right: 22px;
      top: 30px;
    }
  }
}
.class-list-item {
  margin-top: 20px;
  .class-item {
    /deep/.van-tabs__wrap {
      height: 50px;
      &::after {
        content: none;
      }
      .cover {
        display: none;
      }
      .van-tabs__nav {
        padding-bottom: 0;
        background: none;
      }
      .van-tab--active {
        color: #5783fc;
      }
      .van-tabs__line {
        background-color: #5783fc;
        bottom: 0;
      }
      .van-tab--complete {
        flex: none;
        width: 140px;
        height: 50px;
        line-height: 28px;
      }
    }
  }
  .class-child-item {
    margin-top: 20px;
    background-color: #fff;
    border-radius: 5px;
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .class-name {
      position: relative;
      width: 86px;
      height: 25px;
      padding-left: 14px;
      line-height: 25px;
      font-weight: 500;
      color: #383838;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &::before {
        content: '';
        width: 3px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border-radius: 0 1px 1px 0;
        background-color: #5783fc;
      }
    }
    /deep/.van-tabs {
      flex: 1;
      &.van-tabs--card>.van-tabs__wrap {
        height: 22px;
      }
      .cover {
        display: none;
      }
      .van-tabs__nav--card {
        border: none;
        height: 22px;
        padding-left: 0;
        margin: 0;
        .van-tab {
          flex: none;
          font-size: 12px;
          font-weight: 500;
          padding: 0 8px;
          height: 22px;
          line-height: 20px;
          border: 1px solid #5783fc;
          border-radius: 11px;
          color: #5783fc;
          margin-right: 10px;
          &.van-tab--active {
            color: #fff;
            background-color: #5783fc;
          }
        }
      }
    }
    .sort-list-item {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .sort-item {
        margin: 0 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 20px;
        cursor: pointer;
        .name {
          margin-right: 10px;
          color: #64748b;
        }
        .arrow {
          display: flex;
          flex-direction: column;
          .img {
            width: 8px;
            height: 6px;
            &.down {
              transform: rotate(180deg);
              margin-top: -1px;
            }
          }
        }
      }
    }
  }
}
.page-goods-item {
  padding-bottom: 100px;
}
.goods-list-item {
  margin-top: 20px;
  .goods-item {
    display: inline-block;
    background-color: #fff;
    width: 173px;
    // height: 229px;
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
    margin-right: 20px;
    margin-bottom: 20px;
    &:nth-child(6n) {
      margin-right: 0;
    }
    &:hover {
      box-shadow: -4px 0 10px 0 rgba(87, 131, 252, .25);
    }
    .img {
      width: 173px;
      height: 173px;
      border-radius: 5px;
      overflow: hidden;
    }
    .name-item {
      margin-top: 5px;
      line-height: 18px;
      height: 36px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      color: #64748b;
      span {
        height: 15px;
        line-height: 15px;
        padding: 0 2px;
        margin-right: 2px;
        margin-top: 0;
        font-size: 10px;
        color: #fff;
        border-radius: 2px;
        background: linear-gradient( 315deg, #ffaa8a 0%, #ffde58 100%);
      }
    }
    .footer-item {
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .money {
        color: #d43030;
        font-size: 10px;
        font-weight: 500;
        span {
          font-size: 14px;
        }
      }
      .btn {
        padding: 0 5px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background-color: #5783fc;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
        &.not {
          background-color: #64748B;
        }
      }
    }
  }
}
.more-goods-btn {
  margin: 0 auto;
  width: 75px;
  height: 25px;
  border: 1px solid #5783fc;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5783fc;
  font-weight: 500;
  cursor: pointer;
}
</style>
